module.exports = __webpack_public_path__ + "static/media/ohmg.e84c7fb8.png";